module.exports = __webpack_public_path__ + "img/resized-APP-0001-2.ffd0a0ea.png";